export default __webpack_public_path__ + "static/media/Img_Dashboard_Music.80c33721.jpg";